import { useLocation, useNavigate } from 'react-router';
import type { QueryParamAdapterComponent } from 'use-query-params';

/**
 * Adapter for react-router v7
 *
 * see more [v7 support issue](https://github.com/pbeshai/use-query-params/issues/295#issuecomment-2561894676)
 */
export const ReactRouter7Adapter: QueryParamAdapterComponent = ({
  children,
}) => {
  const navigate = useNavigate();

  return children({
    location: useLocation(),
    push: location =>
      navigate({ search: location.search }, { state: location.state }),
    replace: location =>
      navigate(
        { search: location.search },
        { replace: true, state: location.state },
      ),
  });
};
